import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { MonitoreoUsuarioService } from "../../../../generated/grpc/configuracion_monitoreo_pb";
import { grpcMonitoreoUsuarioDatabase } from "../database/GrpcMonitoreoUsuarioDatabase";
import { MonitoreoUsuarioRequest } from "../request/MonitoreoUsuarioRequest";
import { MonitoreoUsuarioResponse } from "../response/MonitoreoUsuarioResponse";
import { fx_createMonitoreoUsuarioGrpcService, toMonitoreoUsuarioResponse } from "./MonitoreoUsuarioGrpcService";

/** Variante gRPC-Web de `MonitoreoUsuarioSaveService` (ver ese archivo): alta
 *  de un monitor de campo (el server genera el PIN y envía las credenciales
 *  por correo). Persiste e invalida el listado del cliente, mismo criterio
 *  que la variante REST. */
export class MonitoreoUsuarioSaveGrpcService
  implements ISaveService<MonitoreoUsuarioRequest, MonitoreoUsuarioResponse>
{
  async saveAsync(
    request: MonitoreoUsuarioRequest,
  ): Promise<MonitoreoUsuarioResponse> {
    const client = createClient(MonitoreoUsuarioService, grpcTransportProvider.get());

    let saved;
    try {
      saved = await client.guardar({
        id: request.id ?? undefined,
        clienteId: request.clienteId,
        nombre: request.nombre,
        email: request.email,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcMonitoreoUsuarioDatabase.putOneAsync(saved);
    fx_createMonitoreoUsuarioGrpcService(saved.clienteId).clearCache();
    return toMonitoreoUsuarioResponse(saved);
  }
}

/** Instancia única del servicio gRPC de alta de monitores. */
export const monitoreoUsuarioSaveGrpcService = new MonitoreoUsuarioSaveGrpcService();
